export default "__VITE_ASSET__uFwTiKt9__"